// extracted by mini-css-extract-plugin
module.exports = {"activeBonusesWrapper":"styles_activeBonusesWrapper__3umvf","typeBonus":"styles_typeBonus__yhunq","activeBonusesContainer":"styles_activeBonusesContainer__3Yppp"};